import React from 'react';
import ContactComponent from '../components/ContactComponent';

function ContactPage() {
  
  return (
    <div>
      <ContactComponent/>
    </div>
  );
}

export default ContactPage;
